export const getPrices = `/core/partner/list/price/model`;
